@if (huntTemplate$ | async; as huntTemplate) {
  <div class="template-wrapper">
    <div class="template-container"></div>
    <cyborg-section class="mx-0 mt-3 px-0">
      <div class="row template-container">
        <div class="col-lg-5 template-content p-4">
          <hyperkit-typography
            class="lib-label"
            variant="emphasized"
            size="sm"
            align="left"
            color="inactive"
            >Hunt Template</hyperkit-typography
          >
          <div class="header-wrapper">
            <div class="template-header">
              <div class="inline">
                <hyperkit-typography
                  display="inline"
                  variant="h3"
                  align="left"
                  color="primary"
                  >{{ huntTemplate.name }}</hyperkit-typography
                >
              </div>
              <div class="inline badges">
                @if (huntTemplate.priority) {
                  <hyperkit-badge
                    indicator="dot"
                    [variant]="huntTemplate.priority | priorityBadge"
                    size="large"
                    [text]="huntTemplate.priority"
                  ></hyperkit-badge>
                }
              </div>
            </div>
            <div class="buttons">
              <hyperkit-button
                size="small"
                icon="edit"
                variant="icon"
                color="secondary"
                (click)="editTemplate()"
              ></hyperkit-button>
              <hyperkit-button
                size="small"
                color="secondary"
                text="Archive"
                (click)="archiveTemplate()"
              ></hyperkit-button>
              <hyperkit-tooltip [text]="tooltip()" position="top" tip="center">
                <hyperkit-button
                  size="small"
                  [disabled]="huntDisabled"
                  color="secondary"
                  icon="plus"
                  text="New Hunt"
                  (click)="newHunt()"
                ></hyperkit-button>
              </hyperkit-tooltip>
            </div>
          </div>
          <div class="meta">
            <div>
              <hyperkit-badge variant="neutral" text="Created"></hyperkit-badge>
              <hyperkit-typography
                display="inline"
                variant="emphasized"
                size="sm"
                align="left"
                color="primary"
                >{{
                  huntTemplate.created | date: 'longDate'
                }}</hyperkit-typography
              >
            </div>
            <div>
              <hyperkit-badge
                variant="neutral"
                text="Last Modified"
              ></hyperkit-badge>
              <hyperkit-typography
                display="inline"
                variant="emphasized"
                size="sm"
                align="left"
                color="primary"
                >{{
                  huntTemplate.lastModified | date: 'longDate'
                }}</hyperkit-typography
              >
            </div>
            <div>
              <hyperkit-badge variant="neutral" text="Author"></hyperkit-badge>
              @if (huntTemplate.author) {
                <hyperkit-typography
                  display="inline"
                  variant="emphasized"
                  size="sm"
                  align="left"
                  color="primary"
                >
                  {{ huntTemplate.author.firstName }}
                  {{ huntTemplate.author.lastName }}</hyperkit-typography
                >
              } @else {
                (deleted)
              }
            </div>
          </div>
          <div class="scroll">
            <div>
              <hyperkit-typography
                display="inline"
                variant="h5"
                align="left"
                color="primary"
                >Abstract</hyperkit-typography
              >
              <hyperkit-markdown
                [md]="huntTemplate.description"
              ></hyperkit-markdown>
            </div>
            <div class="description">
              <hyperkit-typography
                display="inline"
                variant="h5"
                align="left"
                color="primary"
                >Hypothesis</hyperkit-typography
              >
              <hyperkit-markdown
                [md]="huntTemplate.hypothesis"
              ></hyperkit-markdown>
            </div>
          </div>
        </div>
        <kendo-drawer-container>
          <kendo-drawer
            #drawer
            [expanded]="isDrawerExpanded"
            position="end"
            [mode]="'overlay'"
            [mini]="false"
            [width]="drawerWidth"
            (collapse)="onCollapse()"
          >
            <ng-template kendoDrawerTemplate>
              <router-outlet name="drawer"></router-outlet>
            </ng-template>
          </kendo-drawer>
          <kendo-drawer-content>
            <div class="tabs">
              <hyperkit-tab-bar variant="secondary" mode="underline">
                <hyperkit-tab text="Hunt Packages" [selected]="true">
                  <div class="tabItems">
                    @if (
                      nonCustomerHuntPackages$ | async;
                      as nonCustomerHuntPackages
                    ) {
                      @for (
                        huntPackage of nonCustomerHuntPackages;
                        track huntPackage
                      ) {
                        <div
                          class="py-3 item"
                          [routerLink]="[
                            '/research/hunt-package',
                            huntPackage.UUID,
                          ]"
                        >
                          <hyperkit-typography
                            variant="emphasized"
                            size="sm"
                            [routerLink]="[
                              '/research/hunt-package',
                              huntPackage.UUID,
                            ]"
                            display="inline"
                            align="left"
                            color="primary"
                            >{{
                              huntPackage.title || 'Untitled Package'
                            }}</hyperkit-typography
                          >
                          <i
                            class="k-icon k-font-icon k-i-close close"
                            (click)="
                              onClose(huntPackage.UUID);
                              $event.stopPropagation()
                            "
                          ></i>
                        </div>
                      }
                    } @else {
                      <div class="noContent">
                        <hyperkit-typography
                          variant="body"
                          size="sm"
                          align="center"
                          color="body"
                          >No hunt packages to display.</hyperkit-typography
                        >
                      </div>
                    }
                  </div>
                </hyperkit-tab>
                <hyperkit-tab text="Hunts">
                  @if (huntTemplate.hunts?.length > 0) {
                    <div class="tabItems">
                      @for (hunt of huntTemplate.hunts; track hunt) {
                        <div class="py-3 item">
                          @if (hunt.archived) {
                            <div class="archive-wrapper">
                              <hyperkit-typography
                                variant="body"
                                size="sm"
                                align="center"
                                color="inactive"
                                >{{ hunt.name }} (Archived)</hyperkit-typography
                              >
                              <hyperkit-button
                                size="small"
                                color="secondary"
                                text="Unarchive"
                                (click)="unarchiveHunt(hunt)"
                              ></hyperkit-button>
                            </div>
                          } @else {
                            @if (hunt.huntPackages?.length > 0) {
                              <hyperkit-typography
                                variant="emphasized"
                                size="sm"
                                [routerLink]="getRouterLink(hunt)"
                                align="left"
                                color="primary"
                                >{{ hunt.name }}</hyperkit-typography
                              >
                            } @else {
                              <hyperkit-link
                                variant="emphasized"
                                size="sm"
                                [routerLink]="['/hunt', hunt.id]"
                                align="left"
                                color="primary"
                                text="{{ hunt.name }}"
                              ></hyperkit-link>
                            }
                          }
                        </div>
                      }
                    </div>
                  } @else {
                    <div class="noContent">
                      <hyperkit-typography
                        variant="body"
                        size="sm"
                        align="center"
                        color="body"
                        >No hunts to display.</hyperkit-typography
                      >
                      <hyperkit-button
                        class="new-custom"
                        size="small"
                        color="tertiary"
                        [disabled]="huntDisabled"
                        icon="plus"
                        text="Hunt"
                        (click)="newHunt()"
                      ></hyperkit-button>
                    </div>
                  }
                </hyperkit-tab>
                <hyperkit-tab text="Environments">
                  @if (huntTemplate.environments?.length > 0) {
                    <div class="tabItems">
                      @for (
                        environment of huntTemplate.environments;
                        track environment
                      ) {
                        <div
                          class="py-3 item"
                          routerLink="/settings/environment"
                        >
                          <hyperkit-typography
                            variant="emphasized"
                            size="sm"
                            align="left"
                            color="primary"
                            >{{ environment.name }}</hyperkit-typography
                          >
                        </div>
                      }
                    </div>
                  } @else {
                    <div class="noContent">
                      <hyperkit-typography
                        variant="body"
                        size="sm"
                        align="center"
                        color="body"
                        >No environments to display.</hyperkit-typography
                      >
                    </div>
                  }
                </hyperkit-tab>
                <hyperkit-tab text="Saved Queries">
                  @if (huntTemplate.savedQueries?.length > 0) {
                    <div>
                      @for (
                        savedQuery of huntTemplate.savedQueries;
                        track savedQuery
                      ) {
                        <div>
                          <hyperkit-accordion
                            [title]="savedQuery.huntPackageName"
                            [expanded]="false"
                          >
                            <ng-template #headerTemplate>
                              <div class="flex-header">
                                <div class="link">
                                  <hyperkit-typography
                                    variant="emphasized"
                                    size="sm"
                                    align="left"
                                    color="primary"
                                    >{{
                                      savedQuery.huntPackageName
                                    }}</hyperkit-typography
                                  >
                                </div>
                                <hyperkit-typography
                                  variant="body"
                                  size="sm"
                                  align="left"
                                  color="body"
                                >
                                  {{ savedQuery.environment.name }} &bull;
                                  {{ savedQuery.tool.name }} &bull;
                                  {{
                                    savedQuery.savedContent.category
                                  }}</hyperkit-typography
                                >
                              </div>
                            </ng-template>
                            <div class="content">
                              <hyperkit-code-block
                                [code]="savedQuery.savedContent.query"
                              ></hyperkit-code-block>
                              <hyperkit-button
                                class="new-custom"
                                size="small"
                                color="tertiary"
                                variant="icon"
                                icon="trash"
                                (click)="deleteSavedQuery(savedQuery)"
                              ></hyperkit-button>
                            </div>
                          </hyperkit-accordion>
                        </div>
                      }
                    </div>
                  } @else {
                    <div class="noContent">
                      <hyperkit-typography
                        variant="body"
                        size="sm"
                        align="center"
                        color="body"
                        >No saved queries to display.</hyperkit-typography
                      >
                    </div>
                  }
                </hyperkit-tab>
                <hyperkit-tab text="Custom Hunt Packages">
                  <hyperkit-button
                    class="new-custom"
                    size="small"
                    color="tertiary"
                    icon="plus"
                    text="New"
                    (click)="openNewCustomContent()"
                  ></hyperkit-button>
                  <div class="custom-hunt-package tabItems">
                    @if (
                      customerHuntPackages$ | async;
                      as customerHuntPackages
                    ) {
                      @for (
                        huntPackage of customerHuntPackages;
                        track huntPackage
                      ) {
                        <div
                          class="py-3 item"
                          (click)="openExistingCustomContent(huntPackage.UUID)"
                        >
                          <hyperkit-typography
                            display="inline"
                            variant="emphasized"
                            size="sm"
                            align="left"
                            color="primary"
                            >{{
                              huntPackage.title || 'Untitled Package'
                            }}</hyperkit-typography
                          >
                          <hyperkit-icon
                            icon="x"
                            size="base"
                            color="primary"
                            class="close"
                            (click)="onClose(huntPackage.UUID)"
                          >
                          </hyperkit-icon>
                        </div>
                      }
                    } @else {
                      <div class="noContent">
                        <hyperkit-typography
                          variant="body"
                          size="sm"
                          align="center"
                          color="body"
                          >No custom content to display.</hyperkit-typography
                        >
                      </div>
                    }
                  </div>
                </hyperkit-tab>
              </hyperkit-tab-bar>
            </div>
          </kendo-drawer-content>
        </kendo-drawer-container>
      </div>
    </cyborg-section>
  </div>
} @else {
  <div class="loading">
    <kendo-loader
      type="pulsing"
      themeColor="primary"
      size="large"
    ></kendo-loader>
  </div>
}
<div kendoDialogContainer></div>
